

// $Classes/Enums/Interfaces(filter)[template][separator]
// filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
// template: The template to repeat for each matched item
// separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]

// More info: http://frhagn.github.io/Typewriter/


export class SFT_Targets {
    
    public sfT_TargetsID: number = 0;
    public protectiveFunction_FK: number = null;
    public pfDavg: number = null;
    public xpfDavg: string = null;
    public sil: number = null;
    public stR1Year: number = null;
    public xstR1Year: string = null;
    public mttf: number = null;
    public xmttf: string = null;
    public psrt: string = null;
    public createdby: number = null;
    public createdDate: Date = null;
    public updatedby: number = null;
    public updatedDate: Date = null;
    public isDeleted: boolean = null;
    public hftTarget: number = null;
}

